/**
 * The landing page. Admins first get Needs attention (the server sends it to
 * admins only); then one collapsible section per module, so a new module adds
 * its own section rather than more cards.
 *
 * Business Opportunities and the asset catalog each read their own data and
 * fail on their own; see their files for the cards.
 * Every part links into its screen, filtered to what was clicked; those pages
 * are where things are browsed and acted on.
 */

import { useDashboard } from '@/api/queries';
import { useSession } from '@/session/SessionContext';
import { PageHead } from '@/ui/PageHead';

import { AttentionSection } from './AttentionSection';
import { BusinessOpportunitiesModule } from './BusinessOpportunitiesModule';
import { CatalogModule } from './CatalogModule';

function welcome(displayName: string | undefined): string {
  const name = displayName?.trim();
  // A name that ends in a period ("Trochmann Jr.") does not get a second one.
  return `Welcome back${name ? `, ${name}` : ''}${name?.endsWith('.') ? '' : '.'}`;
}

export function DashboardPage() {
  const { user, can } = useSession();
  const dashboard = useDashboard();

  return (
    <>
      <PageHead title="Dashboard" subtitle={welcome(user?.display_name)} />

      {dashboard.data?.attention && <AttentionSection data={dashboard.data.attention} />}

      <div className="dash-columns">
        <BusinessOpportunitiesModule />
        {can('asset.view') && <CatalogModule />}
      </div>
    </>
  );
}
